import React, { useEffect, useState } from "react";
import {
  Alert, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid,
  MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField,
} from "@mui/material";
import { crearConcepto, getConceptos } from "../services/egresosService";

const fieldSx = {
  "& .MuiInputBase-root": { minHeight: 32 },
  "& .MuiInputBase-input": { py: "5px", fontSize: "0.8rem" },
  "& .MuiInputLabel-root": { fontSize: "0.8rem" },
};

// Alta de conceptos de cheque (espejo de co_cg_concepto). Los conceptos nuevos aparecen
// de inmediato en el formulario del cheque (onCreado recarga los catálogos).
export default function ConceptosDialog({ open, onClose, onCreado }) {
  const [lista, setLista] = useState({ conceptos: [], macrocuentas: [] });
  const [cargando, setCargando] = useState(false);
  const [form, setForm] = useState({ concepto: "", cuenta: "", id_macrocuenta: "" });
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");
  const [ok, setOk] = useState("");

  const cargar = () => {
    setCargando(true);
    getConceptos()
      .then((res) => setLista(res.data))
      .catch(() => setError("No se pudo cargar la lista de conceptos."))
      .finally(() => setCargando(false));
  };

  useEffect(() => {
    if (open) {
      setError("");
      setOk("");
      cargar();
    }
  }, [open]);

  const set = (campo) => (e) => setForm((f) => ({ ...f, [campo]: e.target.value }));

  const guardar = async () => {
    setGuardando(true);
    setError("");
    setOk("");
    try {
      await crearConcepto(form);
      setOk(`Concepto "${form.concepto.trim()}" guardado.`);
      setForm({ concepto: "", cuenta: "", id_macrocuenta: "" });
      cargar();
      if (onCreado) onCreado();
    } catch (e) {
      setError(e?.response?.data?.error || "No se pudo guardar el concepto.");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ py: 1, fontSize: "0.95rem", fontWeight: 900 }}>Conceptos de cheque</DialogTitle>
      <DialogContent dividers>
        {error && <Alert severity="error" sx={{ mb: 1, py: 0 }}>{error}</Alert>}
        {ok && <Alert severity="success" sx={{ mb: 1, py: 0 }}>{ok}</Alert>}
        <Grid container spacing={1} sx={{ mb: 1.5 }}>
          <Grid size={{ xs: 12, md: 5 }}><TextField fullWidth size="small" label="Descripción" value={form.concepto} onChange={set("concepto")} sx={fieldSx} /></Grid>
          <Grid size={{ xs: 6, md: 2 }}><TextField fullWidth size="small" label="Cuenta" value={form.cuenta} onChange={set("cuenta")} sx={fieldSx} /></Grid>
          <Grid size={{ xs: 6, md: 3 }}>
            <TextField select fullWidth size="small" label="Macrocuenta" value={form.id_macrocuenta} onChange={set("id_macrocuenta")} sx={fieldSx}>
              {lista.macrocuentas.map((m) => <MenuItem key={m.id} value={m.id}>{m.nombre}</MenuItem>)}
            </TextField>
          </Grid>
          <Grid size={{ xs: 12, md: 2 }}>
            <Button fullWidth size="small" variant="contained" onClick={guardar} disabled={guardando || !form.concepto.trim() || !form.cuenta.trim()} sx={{ height: 32 }}>
              {guardando ? <CircularProgress size={16} color="inherit" /> : "Guardar"}
            </Button>
          </Grid>
        </Grid>
        {cargando ? <Box sx={{ textAlign: "center", py: 2 }}><CircularProgress size={20} /></Box> : (
          <TableContainer sx={{ maxHeight: 360 }}>
            <Table size="small" stickyHeader sx={{ "& .MuiTableCell-root": { py: 0.2, px: 0.6, fontSize: 11 } }}>
              <TableHead>
                <TableRow>
                  {["ID", "Descripción", "Cuenta", "Macrocuenta"].map((h) => <TableCell key={h} sx={{ fontWeight: 800 }}>{h}</TableCell>)}
                </TableRow>
              </TableHead>
              <TableBody>
                {lista.conceptos.map((c) => (
                  <TableRow key={c.id} hover>
                    <TableCell>{c.id}</TableCell><TableCell>{c.concepto}</TableCell>
                    <TableCell>{c.cuenta}</TableCell><TableCell>{c.macrocuenta || "-"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 0.75 }}><Button size="small" onClick={onClose}>Cerrar</Button></DialogActions>
    </Dialog>
  );
}
